import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import SearchBarComp from "../Componants/SearchBarComp";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, putRequest, } from "../services/apiMethods";
import toast from "react-hot-toast";
import useVendorDetails from "../hooks/VendorDetails";


const AddServices = ({ show, handleClose, refetch }) => {
    const { data: selectedServices, refresh } = useVendorDetails();
    const [searchValue, setSearchValue] = useState('');
    const [selectedCategoryIds, setSelectedCategoryIds] = useState([])

    const { data: serviceData, isLoading, isError, error } = useQuery({
        queryKey: ['addservices', searchValue], // The key is still part of the object
        queryFn: () => {
            if (searchValue) {
                return getRequest(`/service/view?search=${searchValue}`);
            } else {
                return getRequest(`/service/view`); // Fetch all services when searchValue is empty
            }
        },
        enabled: true, // Query will run initially with or without searchValue
    });

    if (isError) {
        console.error("Error fetching services:", error);
    }


    const handleSelect = (id) => {
        setSelectedCategoryIds(prevIds => {
            if (prevIds.includes(id)) {
                // If the id is already selected, remove it (unselect)
                return prevIds.filter(existingId => existingId !== id);
            } else {
                // If the id is not selected, add it (select)
                return [...prevIds, id];
            }
        });
    };



    useEffect(() => {
        if (selectedServices?.services) {
            setSelectedCategoryIds(selectedServices?.services)
        }
    }, [show])


    const { mutate, isLoading: apiState } = useMutation({
        mutationFn: (data) => {
            const modifyData = {
                services: data || [],
            };
            return putRequest(`/service/add`, modifyData);
        },
        onSuccess: (data) => {
            toast.success(`${data?.message}`, {
                iconTheme: {
                    primary: '#337FE0',
                    secondary: '#FFFAEE',
                },
            })
            setSelectedCategoryIds([])
            refetch()
            setSearchValue("")
            handleClose()
            refresh()
        },
        onError: (error) => {
            console.error("Error during API call:", error);
        },
    });

    const handleSubmit = () => {
        if (selectedCategoryIds.length > 0) {

            mutate(selectedCategoryIds);
        }
    }

    return (
        <Modal show={show}
            onHide={handleClose}
        >
            <Modal.Body>
                <div>
                    <div className="account-created-pop">
                        <h3>Add Services</h3>
                        <p>
                            You can add more services from here and refine them in your
                            services page
                        </p>
                        <Form className="cmn-form-set">
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Search for Services</Form.Label>

                                <SearchBarComp setSearchValue={setSearchValue} />
                                {/* <Form.Control type="text" placeholder="Type here" /> */}
                            </Form.Group>
                            {Array.isArray(serviceData?.data) &&
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <div className="services-suggestions">
                                        {Array.isArray(serviceData?.data) && serviceData?.data.map((val, index) => {
                                            return (
                                                <div key={index}>
                                                    <p style={{marginBottom:"8px" ,fontWeight: 600}}>{val?.categoryName}</p>
                                                    <ul>
                                                        {Array.isArray(val?.services) && val?.services.map((ele, index) => {
                                                            return (
                                                                <li key={index} style={{ cursor: "pointer" }} onClick={() => handleSelect(ele._id)} className={selectedCategoryIds.includes(ele._id) ? 'activeSelected' : ''}>+ {ele?.serviceName}</li>
                                                            )
                                                        })}

                                                    </ul>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </Form.Group>}
                        </Form>

                        <div className="d-flex justify-content-between mt-4 mb-2">
                            <button
                                className="theme-white-comm-btn"
                                onClick={handleClose}
                            >Cancel
                            </button>
                            <button className={selectedCategoryIds.length === 0 ? 'theme-comm-btn-disabled' : 'theme-comm-btn'} onClick={handleSubmit} disabled={selectedCategoryIds.length === 0}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddServices
